<template>

    <div
        ref="drilldown"
        class="c-a-drilldown"
        :class="{'c-a-drilldown--toggled': showDropdown, 'c-a-drilldown--is-active-sub': activeSubList !== null}"
        @keyup.esc="showDropdown = false"
    >


        <transition name="c-a-drilldown__overlay--animation">
            <div v-if="showDropdown && dimLights" class="c-a-drilldown__overlay" @click="showDropdown = false"></div>
        </transition>
        <label class="c-a-drilldown__label" :for="name">{{label}}</label>
        <div class="c-a-drilldown__wrapper">

            <div class="c-a-input__wrapper c-a-input__wrapper--with-icon-left c-a-input__wrapper--with-button c-a-input__wrapper--full-width">
                <icon
                    class="c-a-input__icon"
                    :icon="'search'"></icon>
                <input
                    type="search"
                    v-model="filterText"
                    ref="search"
                    :placeholder="placeholder"
                    class="c-a-input__input"
                     @click="showDropdown = true" />
                <span class="c-a-drilldown__button" @click="toggleDropdown()">
                    <icon :icon="'expand_more'"></icon>
                </span>
            </div>

            <transition
                name="c-a-drilldown__dropdown--animation"
            >
                <div v-if="showDropdown && filterText.length > 0" ref="drilldown-dropdown" class="c-a-drilldown__dropdown c-a-drilldown__dropdown--height-auto">
                    <ul class="c-a-drilldown__list c-a-drilldown__list--search">
                        <li v-for="subItem in filteredCategories" class="c-a-drilldown__item c-a-drilldown__item--sub" :key="`subitem-${subItem.Id}`">
                            <div
                                class="c-a-drilldown__item-inner"
                                @click="setCategory(subItem)"
                                @keyup.enter="setCategory(subItem)"
                                @keyup.space="setCategory(subItem)"
                                tabindex="0"
                            >
                                <p class="c-a-drilldown__item-title">{{subItem.Name}}</p>
                                <status-pill v-if="hasSecureJob(subItem.Name)"  :status="'direct'">TryggtJobb</status-pill>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-else-if="showDropdown" ref="drilldown-dropdown" class="c-a-drilldown__dropdown">

                    <ul class="c-a-drilldown__list c-a-drilldown__list--main">
                        <li class="c-a-drilldown__item c-a-drilldown__item--heading">
                            {{placeholder}}:
                            <span
                                class="c-a-drilldown__close-button"
                                @click="showDropdown = false"
                                @keyup.enter="showDropdown = false"
                                @keyup.space="showDropdown = false"
                                tabindex="0"
                            >
                                <icon :icon="'close'" />
                            </span>
                        </li>

                        <li v-for="item in items" class="c-a-drilldown__item c-a-drilldown__item--main" :key="`item-${item.Id}`">
                            <div
                                class="c-a-drilldown__item-inner"
                                @click="setActiveSublist(item.Id, item.Link)"
                                @keyup.enter="setActiveSublist(item.Id, item.Link)"
                                @keyup.space="setActiveSublist(item.Id, item.Link)"
                                tabindex="0"
                            >
                                <icon class="c-a-drilldown__hero-icon" :icon="getIconName(item.Name)"></icon>
                                <p class="c-a-drilldown__item-title">{{item.Name}}</p>
                                <status-pill v-if="hasSecureJob(item.Name)"  :status="'direct'">TryggtJobb</status-pill>
                                <icon class="c-a-drilldown__arrow-icon" :icon="'arrow_forward'"></icon>
                            </div>
                            <transition name="c-a-drilldown__sub-list--animation">
                                <ul class="c-a-drilldown__list c-a-drilldown__list--sub" v-show="activeSubList === item.Id">
                                    <li class="c-a-drilldown__item c-a-drilldown__item--sub">
                                        <button
                                            type="button"
                                            class="c-a-drilldown__back-button"
                                            @click="goBack()"
                                            @keyup.enter="goBack()"
                                            @keyup.space="goBack()"
                                        >
                                            <icon :icon="'arrow_back'"></icon>
                                            Tillbaka
                                        </button>
                                    </li>
                                    <li class="c-a-drilldown__item-inner c-a-drilldown__item-inner--headline" tabindex="0">
                                        <icon class="c-a-drilldown__hero-icon" :icon="getIconName(item.Name)"></icon>
                                        <p class="c-a-drilldown__item-title">{{item.Name}}</p>

                                    </li>
                                    <li v-for="subItem in item.Subcategories" class="c-a-drilldown__item c-a-drilldown__item--sub" :key="`subitem-${subItem.Id}`">
                                        <div
                                            class="c-a-drilldown__item-inner"
                                            @click="setCategory(subItem)"
                                            @keyup.enter="setCategory(subItem)"
                                            @keyup.space="setCategory(subItem)"
                                            tabindex="0"
                                        >
                                            <p class="c-a-drilldown__item-title">{{subItem.Name}}</p>
                                            <status-pill v-if="hasSecureJob(subItem.Name)" :status="'direct'">TryggtJobb</status-pill>
                                        </div>
                                    </li>
                                </ul>
                            </transition>
                        </li>
                    </ul>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue'
    import ButtonAtom from '../AtomButton.vue';
    import StatusPill from '../AtomStatus.vue';


    export default {
        props: [
            'name',
            'label',
            'placeholder',
            'value',
            'items',
            'dimLights'
        ],
        data() {
            return {
                showDropdown: false,
                activeSubList: null,
                filterText: ''
            }
        },
        components: {
            Icon,
            ButtonAtom,
            StatusPill,
        },
        computed: {
            chosenCategory: {
                get: function() {
                    return this.value;
                },
                set: function(val) {
                    this.$emit('input', val);
                }
            },
            subcategories:{
                get: function(){
                    let arr = [];
                    if(!this.items) return arr;

                    Object.values(this.items).forEach(item =>  {
                        arr = arr.concat(item.Subcategories);
                    })
                    return arr;
                }
            },
            filteredCategories: {
                get: function(){
                    return this.subcategories.filter(cat => { return cat.Name.toLowerCase().includes(this.filterText.toLowerCase()) });
                }
            },
        },
        methods: {
            setActiveSublist(id, link) {                
                if(link){
                    window.open(link)
                }else{
                    this.activeSubList = id;
                }
            },
            getIconName: function(category) {
                if (category.match(/(INSIDA)/gi)) {
                    return 'bed';
                }
                else if (category.match(/(UTSIDA)/gi)) {
                    return 'home';
                }
                else if (category.match(/(BYGGPROJEKT)/gi)) {
                    return 'business';
                }
                else if (category.match(/(ARKITEKT)/gi)) {
                    return 'pencil_ruler';
                }
                else if (category.match(/(EL, VVS)/gi)) {
                    return 'flash_on';
                }
                else if (category.match(/(TRÄDGÅRD)/gi)) {
                    return 'nature_people';
                }
                else if (category.match(/(SERVICE)/gi)) {
                    return 'dolly';
                }
                else if(category.match(/(MINDRE)/gi)) {
                    return 'carpenter'
                }
                else {
                    return 'hammer_and_wrench';
                }
            },
            hasSecureJob: function(category){
                category = category.toLowerCase();
                return category.match(/(INSIDA)/gi) 
                        || category.match(/(BYGGPROJEKT)/gi) 
                        || category.match(/(UTSIDA)/gi) 
                        || category.match(/(badrum)/gi) 
                        || category.match(/(takarbete)/gi) 
                        || category.match(/(köksrenovering)/gi) 
                        || category.match(/(byggna)/gi) 
                        || category.match(/(totalrenovering)/gi);
                
            },
            centerDropdown() {
                let element = this.$refs['drilldown-dropdown'];
                element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
            },
            toggleDropdown() {
                if (this.showDropdown) {
                    this.showDropdown = false;
                    this.$refs.search.blur();
                    this.filterText = '';
                } else {
                    this.showDropdown = true;
                    this.$refs.search.focus();
                }
            },
            handleClickOutside(event) {
                if (!(this.$el == event.target || this.$el.contains(event.target))) {
                    this.showDropdown = false;
                }
            },
            goBack() {
                this.activeSubList = null;
            },
            setCategory(category) {
                this.chosenCategory = category;
                this.showDropdown = false;
                this.activeSubList = null;
            }
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOutside);
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomDrilldownCategories.vue